export const getConfig = ({ key = '', description = '' }) => {
  let search:any = []
  if (!['STANDARD', 'GENERAL'].includes(key)) {
    search = [
      {
        label: '品牌',
        name: 'brandId',
        itemType: 'select',
        data: 'brandList',
        labelKey: 'name',
        key: 'id',
      },
      { label: '适用产品', name: 'productId', itemType: 'custom', render: 'searchSelectRender' },
      {
        label: '适用门店',
        name: 'companyId',
        itemType: 'select',
        data: 'companyList',
        labelKey: 'name',
        key: 'id',
      },
      {
        label: '特项代码',
        name: 'specialCode',
        itemType: 'select',
        data: 'specialCodeList',
        labelKey: 'showName',
        key: 'code',
      },
    ]
  } else {
    const itemObj = {
      STANDARD: [
        { label: '标配产品编码', name: 'standardProductSkuId' },
        { label: '标配产品名称', name: 'standardProductSkuNameKeyword' },
      ],
      GENERAL: [
        { label: '通项ID', name: 'generalItemId' },
        { label: '通项名称', name: 'generalItemNameKeyword' },
      ],
    }
    search = [
      ...itemObj[key],
      { label: '适用产品', name: 'productId', itemType: 'custom', render: 'searchSelectRender' },
      {
        label: '适用门店',
        name: 'companyId',
        itemType: 'select',
        data: 'companyList',
        labelKey: 'name',
        key: 'id',
      },
      {
        label: '价格类型',
        name: 'priceType',
        itemType: 'select',
        data: 'priceTypeList',
        labelKey: 'description',
        key: 'key',
      },
    
    ]
  }
  const otherConfig = {
    fieldControl: false,
    search,
    footer: [
      { label: '导出', render: 'exportRender' },
      { label: '导入', render: 'importRender' },
      { label: '新增配置', type: 'primary', events: ['onClick:onAdd'] },
    ],
    batchActions: [{ label: '批量删除', danger: true, events: ['onClick:onBatchDelete'] }],
  }

  if (['STANDARD', 'GENERAL'].includes(key)) {
    const itemObj = {
      STANDARD: [
        { title: '标配SKU名称', dataIndex: 'sourceName', width: 200 },
        { title: '标配SKU_ID', dataIndex: 'sourceId', width: 200 },
      ],
      GENERAL: [
        { title: '通项ID', dataIndex: 'sourceId', width: 200 },
        { title: '通项名称', dataIndex: 'sourceName', width: 200 },
      ],
    }
    return {
      columns: [
        { title: '适用产品', dataIndex: 'productName', width: 200 },
        { title: '适用门店', dataIndex: 'companyName', width: 200 },
        ...itemObj[key],
        { title: '价格类型', dataIndex: 'priceTypeName', width: 200 },
        { title: '价格（元）', dataIndex: 'price', width: 200 },
        { title: '开始日期', dataIndex: 'startDate', width: 180, itemType: 'date' },
        { title: '结束日期', dataIndex: 'endDate', width: 180, itemType: 'date' },
        { title: '操作', dataIndex: '#', width: 120, fixed: 'right', render: 'actionRender' },
      ],
      ...otherConfig,
    }
  }
  const grossRateTypeRender = () => {
    if (key === 'gross') {
      return [{ title: '毛利类型', dataIndex: 'grossRateTypeName', width: 120, ellipsis: true }]
    } else {
      return []
    }
  }
  const columns: any[] = [
    { title: '适用产品', dataIndex: 'productName', width: 200 },
    { title: '品牌', dataIndex: 'brandName', width: 200, ellipsis: true },
    { title: '特项代码', dataIndex: 'specialCode', width: 200, ellipsis: true },
    ...grossRateTypeRender(),
    {
      title: '是否通配',
      dataIndex: 'compatibleFlag',
      width: 160,
      render: (v: boolean) => (v ? '是' : '否'),
    },
    { title: '适用门店', dataIndex: 'companyName', width: 200, ellipsis: true },
    { title: description + '(%)', dataIndex: `${key}Value`, width: 200 },
    { title: '开始日期', dataIndex: 'startDate', width: 180, itemType: 'date' },
    { title: '结束日期', dataIndex: 'endDate', width: 180, itemType: 'date' },
    { title: '操作', dataIndex: '#', width: 120, fixed: 'right', render: 'actionRender' },
  ]
  const addItems = [
    {
      title: '是否入库',
      dataIndex: 'isStore',
      width: 160,
      render: (v: boolean) => (v ? '是' : '否'),
    },
  ]

  const columns_ = [...columns]
  key === 'promng' && columns_.splice(2, 0, ...addItems)

  return { columns: columns_, ...otherConfig }
}
